import { SeverityLevel, SeverityName, TlsVersion, WafStatus } from "./constants";

const getSeverityName = (nLevel) => {
  switch (nLevel) {
    case SeverityLevel.INFO:
      return SeverityName.INFO;
    case SeverityLevel.NOTICE:
      return SeverityName.NOTICE;
    case SeverityLevel.WARNING:
      return SeverityName.WARNING;
    case SeverityLevel.ERROR:
      return SeverityName.ERROR;
    case SeverityLevel.CRITICAL:
      return SeverityName.CRITICAL;
    default:
      return SeverityName.UNKNOWN;
  }
};

const getSeverityFromThreatLevel = (threatLevelString) => {
  if (!threatLevelString || "string" !== typeof threatLevelString) {
    return SeverityLevel.INFO;
  }
  switch (threatLevelString.toUpperCase()) {
    case "LOW":
      return SeverityLevel.NOTICE;
    case "MEDIUM":
      return SeverityLevel.WARNING;
    case "HIGH":
      return SeverityLevel.ERROR;
    case "CRITICAL":
      return SeverityLevel.CRITICAL;
    default:
      return SeverityLevel.INFO;
  }
};

const getSeverityColor = (nLevel) => {
  switch (nLevel) {
    case SeverityLevel.INFO:
      return "#00bfff";
    case SeverityLevel.NOTICE:
      return "#bfff00";
    case SeverityLevel.WARNING:
      return "#ffbf00";
    case SeverityLevel.ERROR:
      return "#ff8000";
    case SeverityLevel.CRITICAL:
      return "#e60000";
    default:
      return "#f5f5f5";
  }
};

/**
 * Period-over-period percent change: ((current - baseline) / baseline) * 100.
 * Returns null when baseline is 0 and current > 0 (undefined % change).
 */
const getPercentageFor2Values = (baseline, current) => {
  const base = Number(baseline) || 0;
  const value = Number(current) || 0;
  if (base === 0) {
    if (value === 0) return 0;
    return null;
  }
  return Math.round(((value - base) / base) * 100);
};

/** Display helper for overview trend badges (e.g. "+12%", "-5%", "New"). */
const formatPercentChange = (percent) => {
  if (percent === null || percent === undefined) return "New";
  if (percent > 0) return `+${percent}%`;
  return `${percent}%`;
};

const getStatusString = (status) => {
  if (status === null || status === undefined) return null;
  switch (status) {
    case WafStatus.UNHEALTHY:
      return "Unhealthy";
    case WafStatus.DISABLED:
      return "Disabled";
    case WafStatus.DETECT:
      return "Detection";
    case WafStatus.BLOCK:
      return "Enforced";
    default:
      // Unknown enum value — surface as "Unknown" so a mistuned
      // upstream doesn't silently render as "Enforced". Previously
      // any value not matched above collapsed to "Enforced" via a
      // `default:` arm, which meant a new WafStatus enum entry would
      // mislabel itself as blocking until the case landed here.
      return "Unknown";
  }
};

const getTLSVersionString = (version) => {
  switch (version) {
    case TlsVersion.TLS_1_0:
      return "TLS v1.0";
    case TlsVersion.TLS_1_1:
      return "TLS v1.1";
    case TlsVersion.TLS_1_2:
      return "TLS v1.2";
    case TlsVersion.TLS_1_3:
      return "TLS v1.3";
    case TlsVersion.TLS_1_4:
      return "TLS v1.4";
    default:
      return "-";
  }
};

export {
  getSeverityName,
  getSeverityFromThreatLevel,
  getSeverityColor,
  getPercentageFor2Values,
  formatPercentChange,
  getStatusString,
  getTLSVersionString,
};
